import { Button, Box, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, ListItemIcon, ListItemText, Typography, SvgIcon } from "@mui/material";
import { ErrorRounded, CheckRounded } from "@mui/icons-material";
import PersonAddRoundedIcon from "@mui/icons-material/PersonAddRounded";
import MailIcon from "@mui/icons-material/Mail";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";
type ConfirmationModalProps = {
  sentEmails: string[];
  onClose: () => void;
  onResetSentEmails: () => void;
  roleName: string;
  failedInvites: Record<string, string>;
};
export const ConfirmationModal = ({
  sentEmails,
  onClose,
  onResetSentEmails,
  roleName,
  failedInvites
}: ConfirmationModalProps) => {
  const {
    t
  } = useTranslation();
  const hasFailedInvites = !!Object.keys(failedInvites).length;
  const hasSuccessfulInvites = !!sentEmails.length;
  const generateHeaderText = () => {
    if (hasFailedInvites && hasSuccessfulInvites) {
      const failedCount = Object.keys(failedInvites).length;
      const totalCount = failedCount + sentEmails.length;
      return t("shell.invitesSentPartial", {
        count: totalCount,
        successCount: sentEmails.length,
        totalCount
      });
    }
    if (hasFailedInvites && !hasSuccessfulInvites) {
      return t("shell.unableToInviteUsers", {
        count: Object.keys(failedInvites).length
      });
    }
    if (!hasFailedInvites && hasSuccessfulInvites) {
      return t("shell.invitesSentSuccess", {
        count: sentEmails.length
      });
    }
  };
  return <Dialog open onClose={onClose} fullWidth maxWidth={"xs"} data-sentry-element="Dialog" data-sentry-component="ConfirmationModal" data-sentry-source-file="ConfirmationDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ConfirmationDialog.tsx">
        <SvgIcon component={hasFailedInvites ? ErrorRounded : CheckRounded} color={hasFailedInvites ? "error" : "success"} sx={{
        padding: 1,
        borderRadius: "20px",
        backgroundColor: hasFailedInvites ? "red.100" : "green.100",
        display: "block",
        width: "40px",
        height: "40px",
        mb: 1.5
      }} data-sentry-element="SvgIcon" data-sentry-source-file="ConfirmationDialog.tsx" />
        <Typography variant="h5" fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="ConfirmationDialog.tsx">
          {generateHeaderText()}
        </Typography>

        <Typography sx={{
        mt: 1
      }} variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="ConfirmationDialog.tsx">
          {t("shell.seeListBelow")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ConfirmationDialog.tsx">
        {sentEmails.map(email => <ListItem divider dense disableGutters sx={{
        borderColor: "border"
      }}>
            <ListItemIcon sx={{
          minWidth: 28
        }}>
              <CheckCircleRoundedIcon fontSize="small" color="success" />
            </ListItemIcon>
            <ListItemText sx={{
          "& .MuiListItemText-primary": {
            display: "flex",
            justifyContent: "space-between"
          }
        }}>
              <Typography variant="body2" color="text.primary">
                {email}
              </Typography>
              <Typography variant="body2">{t("shell.inviteSent")}</Typography>
            </ListItemText>
          </ListItem>)}
        {Object.entries(failedInvites)?.map(([email, reason]) => <ListItem divider dense disableGutters sx={{
        borderColor: "border"
      }}>
            <ListItemIcon sx={{
          minWidth: 28
        }}>
              <ErrorRoundedIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText sx={{
          "& .MuiListItemText-primary": {
            display: "flex",
            justifyContent: "space-between"
          }
        }}>
              <Typography variant="body2" color="text.primary">
                {email}
              </Typography>
              <Typography variant="body2">{reason}</Typography>
            </ListItemText>
          </ListItem>)}
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="ConfirmationDialog.tsx">
        <Button color="inherit" variant="outlined" onClick={onResetSentEmails} data-sentry-element="Button" data-sentry-source-file="ConfirmationDialog.tsx">
          {t("shell.inviteMorePeople")}
        </Button>
        <Button color="primary" variant="contained" onClick={() => onClose()} data-sentry-element="Button" data-sentry-source-file="ConfirmationDialog.tsx">
          {t("common.done")}
        </Button>
      </DialogActions>
    </Dialog>;
};